import React, { ReactNode } from 'react'
import ReactModal from 'react-modal'
import { GrFormClose } from 'react-icons/gr'

import styles from './styles.module.scss'

export interface ModalProps {
  content: ReactNode
  onRequestClose: () => void
  shouldCloseOnEsc?: boolean
  shouldCloseOnOverlayClick?: boolean
  size?: Sizes
  title: string
}

export type Sizes = 'sm' | 'md' | 'lg' | 'xl'

export const Modal = ({
  content,
  onRequestClose,
  shouldCloseOnEsc,
  shouldCloseOnOverlayClick,
  size = 'md',
  title = ''
}: ModalProps) => {
  return (
    // @ts-expect-error - react-modal tem incompatibilidade de tipos com React 18
    <ReactModal
      isOpen={!!content}
      shouldCloseOnEsc={shouldCloseOnEsc}
      onRequestClose={onRequestClose}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      className={`${styles.container} ${styles[size]} ${styles.slideIn} ${styles.animate}`}
      overlayClassName={styles.overlay}
      ariaHideApp={false}
    >
      <div className={styles.header}>
        <h5 className={styles.title}>{title}</h5>
        <button type="button" className={styles.close} onClick={onRequestClose}>
          <GrFormClose />
        </button>
      </div>
      <div className={styles.content}>{content}</div>
    </ReactModal>
  )
}
